(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Sportsdata"] = factory();
	else
		root["Sportsdata"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VERSION = undefined;
	
	var _package = __webpack_require__(57);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _constants = __webpack_require__(54);
	
	var _search = __webpack_require__(52);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _selectContentChange = __webpack_require__(58);
	
	var _selectContentChange2 = _interopRequireDefault(_selectContentChange);
	
	var _multiselect = __webpack_require__(59);
	
	var _multiselect2 = _interopRequireDefault(_multiselect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Voonto = Voonto,
	    $ = _Voonto.$;
	
	
	Voonto.ready.then(function (app) {
	  var config = app.lookup(_constants.CONFIG_NAMESPACE);
	
	  $('[data-voc-sportsdata-search]').each(function () {
	    new _search2.default($(this), config);
	  });
	  $('[data-voc-sportsdata-select-content-change]').each(function () {
	    new _selectContentChange2.default($(this));
	  });
	  $('[data-voc-sportsdata-multiselect]').each(function () {
	    new _multiselect2.default($(this));
	  });
	});
	
	var VERSION = exports.VERSION = _package2.default.version;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Fill the select options of the SportsData Search.
	 * Add the `dependent select` behavior to the `competition`
	 *  with respect to `sport`, and the `page` with respect to `competition`.
	 * Add `redirect on change` behavior to `page select`.
	 */
	var Search = function () {
	  function Search(element$, _ref) {
	    var _this = this;
	
	    var search = _ref.search;
	
	    _classCallCheck(this, Search);
	
	    this.element$ = element$;
	    this.config = search;
	    this.sportSelect$ = element$.find('[data-voc-sportsdata-search-sport]').removeAttr('disabled');
	    this.competitionSelect$ = element$.find('[data-voc-sportsdata-search-competition]');
	    this.pageSelect$ = element$.find('[data-voc-sportsdata-search-page]');
	
	    // NOTE: Selects events
	    this.sportSelect$.on('change', function () {
	      _this.fillCompetitionSelect();
	      _this.fillPageSelect();
	      _this.competitionSelect$.removeAttr('disabled');
	    });
	    this.competitionSelect$.on('change', function () {
	      _this.fillPageSelect();
	      _this.pageSelect$.removeAttr('disabled');
	    });
	    this.pageSelect$.on('change', function (e) {
	      window.location = Voonto.$(e.target).val();
	    });
	
	    this.fillSelects();
	  }
	
	  _createClass(Search, [{
	    key: 'buildOptionTemplate',
	    value: function buildOptionTemplate(value, name, selected) {
	      return '<option value="' + value + '" ' + (selected ? ' selected="selected"' : '') + '>' + name + '</option>';
	    }
	  }, {
	    key: 'fillSportSelect',
	    value: function fillSportSelect() {
	      this.sportSelect$.find('option:not(:first)').remove();
	      if (this.config.sports) {
	        for (var sport in this.config.sports) {
	          this.sportSelect$.append(this.buildOptionTemplate(sport, this.config.sports[sport]));
	        }
	      }
	    }
	  }, {
	    key: 'fillCompetitionSelect',
	    value: function fillCompetitionSelect() {
	      this.competitionSelect$.find('option:not(:first)').remove();
	      var sportSelected = this.sportSelect$.val();
	      if (this.config.competitions && this.config.competitions[sportSelected]) {
	        var competitions = this.config.competitions[sportSelected];
	        for (var competition in competitions) {
	          this.competitionSelect$.append(this.buildOptionTemplate(competition, competitions[competition]));
	        }
	      }
	    }
	  }, {
	    key: 'fillPageSelect',
	    value: function fillPageSelect() {
	      this.pageSelect$.find('option:not(:first)').remove();
	      var competitionSelected = this.competitionSelect$.val();
	      if (this.config.pages && this.config.pages[competitionSelected]) {
	        var pages = this.config.pages[competitionSelected];
	        for (var page in pages) {
	          this.pageSelect$.append(this.buildOptionTemplate(pages[page].url, pages[page].name));
	        }
	      }
	    }
	  }, {
	    key: 'fillSelects',
	    value: function fillSelects() {
	      this.fillSportSelect();
	      this.fillCompetitionSelect();
	      this.fillPageSelect();
	    }
	  }]);
	
	  return Search;
	}();
	
	exports.default = Search;

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONFIG_NAMESPACE = exports.CONFIG_NAMESPACE = 'vocento.config.sportsdata';
	var CLASS_ITEM = exports.CLASS_ITEM = '.clasificacion-item';
	var CLASS_ITEM_LAST = exports.CLASS_ITEM_LAST = '.voc-ns-last-jornada';

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports = {
		"name": "sportsdata",
		"version": "1.1.15",
		"description": "",
		"main": "src/index.js",
		"scripts": {
			"test": "./node_modules/.bin/webpack && ./node_modules/.bin/mocha-phantomjs dist/spec/index.html --reporter xunit --file test-results.xml",
			"start": "webpack-dev-server",
			"build": "./node_modules/.bin/webpack"
		},
		"contributors": [
			"Iván Pérez <ivanperez@vocento.com>",
			"Ernesto V. <evladpereda@ces.vocento.com>"
		],
		"license": "SEE LICENSE IN LICENSE.md",
		"devDependencies": {
			"babel-core": "^6.17.0",
			"babel-loader": "^6.2.5",
			"babel-preset-es2015": "^6.16.0",
			"chai": "^3.5.0",
			"chalk": "^1.1.3",
			"html-webpack-plugin": "^2.24.1",
			"json-loader": "^0.5.4",
			"mocha": "^3.1.0",
			"mocha-loader": "^1.0.0",
			"mocha-phantomjs": "^4.1.0",
			"webpack": "^1.13.3",
			"webpack-shell-plugin": "^0.4.3"
		}
	};

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectContentChange = function () {
	  function SelectContentChange(element$) {
	    _classCallCheck(this, SelectContentChange);
	
	    this._element$ = element$;
	    this._select$ = this._element$.find('select');
	
	    this._select$.on('change', this.onChange.bind(this));
	  }
	
	  _createClass(SelectContentChange, [{
	    key: 'onChange',
	    value: function onChange() {
	      this._element$.find('.tab-pane.active[data-voc-sportsdata-select-content-change-panel]').removeClass('active');
	      this._element$.find('[data-voc-sportsdata-select-content-change-panel="' + this._select$.val() + '"]').addClass('active');
	    }
	  }]);
	
	  return SelectContentChange;
	}();
	
	exports.default = SelectContentChange;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(54);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Multiselect = function () {
	  function Multiselect(element$) {
	    _classCallCheck(this, Multiselect);
	
	    this._selects$ = element$;
	
	    this._selectRound$ = this._selects$.find('[data-voc-sportsdata-multiselect-round]');
	    this._selectGroup$ = this._selects$.find('[data-voc-sportsdata-multiselect-group]');
	    this._results$ = $('[data-voc-sportsdata-multiselect-results]');
	
	    this._selectRound$.on('change', this.onChange.bind(this));
	    this._selectGroup$.on('change', this.onChange.bind(this));
	
	    this._selectRound$.trigger('change');
	  }
	
	  _createClass(Multiselect, [{
	    key: 'onChange',
	    value: function onChange() {
	      var round, group;
	      round = this._selectRound$.val();
	      group = this._selectGroup$.val();
	
	      this._results$.find('[data-voc-sportsdata-multiselect-group]').hide();
	
	      if (group !== '0') {
	        this._results$.find('[data-voc-sportsdata-multiselect-round="' + round + '"][data-voc-sportsdata-multiselect-group="' + group + '"]').show();
	        this._results$.find('[data-voc-sportsdata-multiselect-round="' + round + '"][data-voc-sportsdata-multiselect-group="' + group + '"]:first').prev().show();
	      } else {
	        this._results$.find('[data-voc-sportsdata-multiselect-round="' + round + '"]').show();
	        this._results$.find('[data-voc-sportsdata-multiselect-round="' + round + '"]' + _constants.CLASS_ITEM + ':not(' + _constants.CLASS_ITEM_LAST + ')').prev().show();
	      }
	    }
	  }]);
	
	  return Multiselect;
	}();
	
	exports.default = Multiselect;

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// sportsdata.js